import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';

import { ActivitySubscriptionType } from '@core/activities-types';
import { I18nService } from '@core/i18n-legacy';
import { TableComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-activity-subscriptions-table',
  templateUrl: './activity-subscriptions-table.component.html',
  styleUrls: ['./activity-subscriptions-table.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TableComponent],
})
export class ActivitySubscriptionsTableComponent {
  private readonly i18n = inject(I18nService);

  public readonly typeTranslations = {
    [ActivitySubscriptionType.Web]: this.i18n.translate('app.subscriptions.types.web_v2'),
    [ActivitySubscriptionType.Mobile]: this.i18n.translate('app.subscriptions.types.mobile_v2'),
    [ActivitySubscriptionType.Email]: this.i18n.translate('app.subscriptions.types.email'),
    [ActivitySubscriptionType.Slack]: this.i18n.translate('app.subscriptions.types.slack'),
  };

  public readonly types = input<ActivitySubscriptionType[]>(undefined!);
  public readonly title = input<string>(undefined!);

  public trackByType(index: number, type: ActivitySubscriptionType): ActivitySubscriptionType {
    return type;
  }
}
